import React from "react"
import Logo from "../../assets/tap2tech/logo.png"
import { Link } from "react-router-dom"

const Error404 = () => {
    return (
        <div className="h-screen w-full flex items-center justify-center">
            <div className="flex flex-col items-center justify-center">
                <h1 className="text-center mb-4">Página no encontrada</h1>
                <img src={Logo} alt="logo tap2tech" className="md:w-[400px] sm:w-[300px] mx-auto" />
                <Link to="/" className="text-center px-6 py-2 bg-tap2tech_sec rounded-lg mt-4 uppercase font-bold">
                    Página principal
                </Link>
            </div>
        </div>
    );
};

export default Error404;